/**
 * rich-text-styling — les valeurs de taille et de couleur proposées par le
 * tiptap du builder (bulle inline et éditeur modal lisent la même table).
 *
 * TAILLES — relatives (`em`), jamais des pixels : un bloc du builder est
 * responsive par requêtes de conteneur, sa typographie est déjà dimensionnée
 * par les classes du champ hôte. Un `font-size: 16px` posé sur un mot fige
 * ce mot à 16px sur mobile comme sur desktop et casse la cascade du bloc ;
 * un multiplicateur suit le champ partout.
 *
 * COULEURS — des jetons du design system Cosmos (`var(--…)` de index.css),
 * pas des hex écrits en dur : la page suit ainsi le thème du site. Le
 * sélecteur libre reste offert à l'auteur pour une couleur de marque absente
 * de la liste — c'est du contenu créé au runtime, pas de l'UI Orbit.
 */

export const TEXT_SIZES = [
  { label: '75 %', value: '0.75em' },
  { label: '90 %', value: '0.9em' },
  { label: '110 %', value: '1.1em' },
  { label: '125 %', value: '1.25em' },
  { label: '150 %', value: '1.5em' },
  { label: '200 %', value: '2em' },
]

export const TEXT_COLORS = [
  { label: 'Titre',     value: 'var(--text-strong)' },
  { label: 'Corps',     value: 'var(--text-body)' },
  { label: 'Atténué',   value: 'var(--text-muted)' },
  { label: 'Primaire',  value: 'var(--iris-600)' },
  { label: 'Aurore',    value: 'var(--cyan-600)' },
  { label: 'Succès',    value: 'var(--emerald-600)' },
  { label: 'Attention', value: 'var(--amber-700)' },
  { label: 'Danger',    value: 'var(--rose-600)' },
  { label: 'Blanc',     value: 'var(--white)' },
]

/** Le libellé court affiché sur le déclencheur du menu « Taille ». */
export const currentSizeLabel = (editor) => {
  const size = editor.getAttributes('textStyle').fontSize
  if (!size) return '100 %'
  return TEXT_SIZES.find(s => s.value === size)?.label ?? size
}

/** La couleur courante, ou `null` quand le texte hérite de celle du champ. */
export const currentColor = (editor) => editor.getAttributes('textStyle').color || null

/**
 * Une couleur libre n'est proposée au sélecteur natif qu'en hexadécimal :
 * un jeton `var(--…)` n'en est pas un et le ferait retomber sur du noir.
 */
export const asHexOrDefault = (color) => (/^#[0-9a-f]{6}$/i.test(color ?? '') ? color : '#000000')
